(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuvori-social-proof-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nuvori-social-proof-carousel')) {
    class NuvoriSocialProofCarousel extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.track = this.querySelector('[data-social-proof-track]');
        this.previousButton = this.querySelector('[data-social-proof-previous]');
        this.nextButton = this.querySelector('[data-social-proof-next]');
        if (!this.track || !this.previousButton || !this.nextButton) return;

        this.handlePrevious = () => this.move(-1);
        this.handleNext = () => this.move(1);
        this.handleScroll = () => window.requestAnimationFrame(() => this.updateButtons());
        this.handleKeydown = (event) => {
          if (event.key === 'ArrowLeft') this.move(-1);
          if (event.key === 'ArrowRight') this.move(1);
        };

        this.previousButton.addEventListener('click', this.handlePrevious);
        this.nextButton.addEventListener('click', this.handleNext);
        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        this.track.addEventListener('keydown', this.handleKeydown);

        this.resizeObserver = new ResizeObserver(() => this.updateButtons());
        this.resizeObserver.observe(this.track);
        this.updateButtons();
      }

      disconnectedCallback() {
        if (!this.track) return;
        this.previousButton?.removeEventListener('click', this.handlePrevious);
        this.nextButton?.removeEventListener('click', this.handleNext);
        this.track.removeEventListener('scroll', this.handleScroll);
        this.track.removeEventListener('keydown', this.handleKeydown);
        this.resizeObserver?.disconnect();
        delete this.dataset.initialized;
      }

      move(direction) {
        const card = this.track.querySelector('[data-social-proof-card]');
        if (!card) return;
        const gap = Number.parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
        const distance = card.getBoundingClientRect().width + gap;
        this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
      }

      updateButtons() {
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const current = Math.abs(this.track.scrollLeft);
        const canScroll = maximum > 2;

        this.previousButton.hidden = !canScroll;
        this.nextButton.hidden = !canScroll;
        this.previousButton.disabled = current <= 2;
        this.nextButton.disabled = current >= maximum - 2;
      }
    }

    customElements.define('nuvori-social-proof-carousel', NuvoriSocialProofCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
